<div class="position-relative"  id="{{'item-' + pollResult.id}}">

    <div class="media card topic-card position-relative" id="{{pollResult.id}}" [ngClass]="{'recurring-poll': pollResult.isRecurring}">
      
        <div class="timeline-item-badge">
            {{'poll_results' | translate }}
            @if(pollResult.reviewed.length > 0){
                <review-badge [reviewInfo]="pollResult.reviewed"></review-badge>
            }
        </div>
                 
        <div class="card-top">
            <div class="pt-2 pe-2">
                <i class="fa-sharp-duotone fa-solid fa-chart-simple fa-2x ms-2 pt-1 position-relative"></i>
            </div>

                <div class="card-comment p-3" [ngClass]="{'not-recurring-poll': !pollResult.isRecurring}">
                    <p class="pb-0">{{pollResult.label}}</p>
                    
                    <mat-tab-group (selectedTabChange)="onTabChanged($event);">
                        <mat-tab [label]="resultsTabLabel">
                            <ng-template matTabContent>
                                @if(pollResult.results?.values && participationCount > 0){
                                    @if(dontWantToAnswerItem.count !== participationCount){
                                        <div class="result-container mt-5">
                                            <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
                                            <div class="score">{{average.averageScore}} <sub>/5</sub></div>
                                        </div>
                                        <p class="infos pb-2">
                                            @if(average.people === 1){
                                                {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answer' | translate}}
                                            }@else{
                                                {{'poll_results.stars_based' | translate}} {{average.people}} {{ 'poll_results.stars_answers' | translate}}
                                            }
                                            @if(dontWantToAnswerItem.count > 0){
                                                <small class="d-block">
                                                    {{'poll_results.stars_additionally' | translate}} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
                                                    @if(dontWantToAnswerItem.count === 1){
                                                        {{'poll_results.stars_time' | translate}}
                                                    }@else{
                                                        {{'poll_results.stars_times' | translate}}
                                                    }
                                                </small>
                                            }
                                        </p>
                                    }@else {
                                        <div class="alert alert-warning pb-1">
                                            <div class="stars" [ngStyle]="{'--rating': average.averageScore}"></div>
                                            <div class="text-center fs-6 fst-italic">{{'poll_results.stars_no-answer' | translate}}</div>
                                        </div>
                                        <small class="d-block text-center fs-6 fst-italic">
                                            {{ 'poll_results.stars_option' | translate }} "{{dontWantToAnswerItem.label}}" {{ 'poll_results.stars_dont-want-answer' | translate}} {{dontWantToAnswerItem.count}} 
                                            @if(dontWantToAnswerItem.count === 1){
                                                {{'poll_results.stars_time' | translate}}
                                            }@else{
                                                {{'poll_results.stars_times' | translate}}
                                            }
                                        </small>
                                    }
                                   
                                }@else{
                                    <div class="alert alert-warning mt-2 mb-0 fs-6 fst-italic">
                                        {{'poll_results.no_data'| translate}}
                                    </div>
                                }
                            </ng-template>
                        </mat-tab>
    
                        <mat-tab [label]="trendsTabLabel" [disabled]='!pollResult.isRecurring'>
                            <ng-template matTabContent>
                                @if(tabIndexToShow === 1){
                                    {{pollResult.results.values.length}}
                                    <recurring-poll-result-trends [poll]="pollResult"></recurring-poll-result-trends>
                                }
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
        
            <div class="card-options"></div>
        </div>

         <div class="card-result-comments">
            <poll-result-comments [commentResults]="pollResult.results.values"
                                  [itemType]="pollResult.itemType"></poll-result-comments>
        </div>

        <div class="media-bottom card-bottom">
            <tm-reactions [timelineItem]="pollResult"
                          (onReacted)="onReacted($event)"
                          (onToggleThreads)="toggleThreads()"
                          (onDiscuss)="discuss()"></tm-reactions>

            @if(showThreads){
                <tm-threads [timelineItem]="pollResult" #threadsComponent
                            [userInfos]="userInfos"
                            (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
            }
        </div>
        
    </div>

    @if(pollResult.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="pollResult.managerPanel"
                              [reviewed]="pollResult.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>